/**
 * RequireNonEnterprise - Route guard for public pricing page
 * 
 * Prevents enterprise users from accessing the public pricing page
 * and redirects them appropriately based on their verification status.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import { auth } from '../../../firebase/firebase';
import AuthLoadingScreen from '../../shared/AuthLoadingScreen';

function RequireNonEnterprise({ children }) {
  const { user, loading } = useAuth();

  console.log('RequireNonEnterprise: Component called with user:', {
    userId: user?.uid,
    isEnterpriseUser: user?.isEnterpriseUser,
    email: user?.email,
    loading,
    emailVerified: auth.currentUser?.emailVerified,
    hasFirebaseUser: !!auth.currentUser
  });

  // Show loading while checking auth
  if (loading) {
    console.log('RequireNonEnterprise: Auth still loading, showing loading screen');
    return <AuthLoadingScreen />;
  }

  // Check if user is enterprise - ONLY by database flag, NOT by email domain
  const isEnterpriseUser = user?.isEnterpriseUser === true || user?.isEnterprise === true;

  // If Firebase user exists and is enterprise, redirect appropriately
  if (auth.currentUser && isEnterpriseUser) {
    console.log('RequireNonEnterprise: Enterprise user detected (Firebase user exists), checking verification status...', {
      firebaseUserEmail: auth.currentUser.email,
      isEnterpriseUser: user?.isEnterpriseUser,
      emailVerified: auth.currentUser.emailVerified
    });
    
    // Check if enterprise user needs email verification first
    if (!auth.currentUser.emailVerified) {
      console.log('RequireNonEnterprise: Enterprise user needs email verification, redirecting to verify-email page');
      return <Navigate to="/verify-email" replace />;
    } else {
      console.log('RequireNonEnterprise: Verified enterprise user, redirecting to app');
      return <Navigate to="/app/" replace />;
    }
  }

  console.log('RequireNonEnterprise: Non-enterprise user or unauthenticated user, allowing access to public pricing page');
  // Allow all non-enterprise users (both authenticated and unauthenticated) to access public pricing
  return children;
}

export default RequireNonEnterprise;

